import React from 'react';
import SocialsBar from './SocialsBar';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
      <SocialsBar></SocialsBar>
    </div>
  );
}

export default Footer;
